import {combineReducers} from 'redux';
import auth from './auth';
import customer from './customer';
import order from './order';
import sampleHardening from './sample-hardening';
import { routerReducer } from 'react-router-redux';
import { reducer as notifReducer } from 'redux-notifications';
import { reducer as modalReducer } from '../containers/modal';

export default combineReducers({
	auth,
	customer,
	order,
	sampleHardening,
	notifs: notifReducer,
	modals: modalReducer,
	routing: routerReducer
});



/** WEBPACK FOOTER **
 ** ./js/reducers/index.js
 **/